var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/buffer/node_modules/isarray/index.js
// module id = Ht8P
// module chunks = 1